import { Container, Hex } from '@acies/core';

/**
 * A dimmed, blurred layer over the whole window, which a dialog sits in the middle of.
 *
 * Fixed and pinned to all four edges rather than sized, so it covers the window however it is scrolled or resized: `hug` leaves no width or height of its own to fight the insets. What is behind it stays visible but out of reach, which is what tells the user the dialog is the one thing they can work with.
 *
 * Meant to be extended rather than filled from outside, and added as the last child of whatever it covers, one step up the stacking order, so nothing drawn after it or beside it can end up on top of it. Whether it is on screen is the subclass's to decide, through `visible`, rather than the overlay being added and
 * removed.
 */
export default class FullscreenOverlay extends Container {
	public constructor() {
		super();
		this.position = 'fixed';
		this.top = 0;
		this.right = 0;
		this.bottom = 0;
		this.left = 0;
		// being the last child is not enough on its own: a sibling that sets a stacking order of its
		// own still lies above anything that does not
		this.zIndex = 1;
		this.alignment = 'center';
		this.fill = new Hex('#000000', 0.4);
		// no property for it on Container, and it is a look that never changes, so it is set once here
		this.style.backdropFilter = 'blur(5px)';
	}
}
customElements.define('ac-fullscreen-overlay', FullscreenOverlay);
